NtechApp.FollowFavoriteManager = function() {
    var me = this;

    this._ajax = null;
    this._click = null;

    this._construct = function() {
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen($("body"), "[data-triggerToggleFollow]", function(event) {
            var $control = $(event.target).closest("[data-triggerToggleFollow]");
            var accountId = $control.attr("data-triggerToggleFollow");

            if($control.hasClass("lockedButton"))
                return;

            $control.addClass("lockedButton");
            me._toggleFollow(accountId, $control);
        });

        me._click.listen($("body"), "[data-triggerToggleFavorite]", function(event) {
            var $control = $(event.target).closest("[data-triggerToggleFavorite]");
            var accountId = $control.attr("data-triggerToggleFavorite");

            if($control.hasClass("lockedButton"))
                return;

            $control.addClass("lockedButton");
            me._toggleFavorite(accountId, $control);
        });

        $(NtechApp.contactManager).on(NtechApp.ContactManager.EVENT_CONTACT_REMOVE, function() {
            $("body").find("[data-triggerToggleFavorite]").css("display", "none");
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.FollowFavoriteManager, {
    _getToggleFavoritesRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_toggle_favorite';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_toggle_favorite';
    },

    _toggleFollow: function(accountId, $item) {
        var me = this;
        var params = {
            accountId: accountId
        };

        $item.find("[data-ajaxHide]").css("display", "none");
        $item.find("[data-ajaxLoaderText]").text("");

        me._ajax.enableTextLoading($item.find("[data-ajaxLoaderText]"));

        me._ajax.post({
            url: Routing.generate("personal_toggle_follow"),
            data: params,
            onSuccess: function(data) {
                if(data.wasFollowed) {
                    var msg = "You are now following " + $item.attr("data-accountFullname") + ".";
                    $item.addClass("selectedControl");
                    $item.find("[data-text]").text("Following");
                }
                else {
                    var msg = "You have unfollowed " + $item.attr("data-accountFullname") + ".";
                    $item.removeClass("selectedControl");
                    $item.find("[data-text]").text("Follow");
                }

                $item.find("[data-ajaxHide]").css("display", "inline-block");
                NtechApp.info.on(msg, 2500);
            },
            onComplete: function() {
                $item.removeClass("lockedButton");
                me._ajax.disableTextLoading($item.find("[data-ajaxLoaderText]"));
            }
        });
    },

    _toggleFavorite: function(accountId, $item) {
        var me = this;
        var params = {
            accountId: accountId
        };

        $item.find("[data-ajaxHide]").css("display", "none");
        $item.find("[data-ajaxLoaderText]").text("");

        me._ajax.enableTextLoading($item.find("[data-ajaxLoaderText]"));

        me._ajax.post({
            url: Routing.generate(me._getToggleFavoritesRoute()),
            data: params,
            onSuccess: function(data) {
                if(data.wasSavedInFavorites) {
                    var msg = $item.attr("data-accountFullname") + " was saved in favorites.";
                    $item.addClass("selectedControl");
                }
                else {
                    var msg = $item.attr("data-accountFullname") + " was removed from favorites.";
                    $item.removeClass("selectedControl");
                }

                $item.find("[data-ajaxHide]").css("display", "inline-block");
                NtechApp.info.on(msg, 2500);
            },
            onComplete: function() {
                $item.removeClass("lockedButton");
                me._ajax.disableTextLoading($item.find("[data-ajaxLoaderText]"));
            }
        });
    }
});